import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../../app";
import { Api } from "../../app-api";
import { Gtm } from "../../app-gtm";
import * as m from "./register-models";
import { ViewModel as root } from "../register";

export class ChooseSkillLevels extends m.Form {
    filter = ko.observable<m.Filter>();

    skillLevels = ko.observableArray<m.SkillLevel>();

    filteredSkillLevels: ko.Computed<m.SkillLevel[]>;
    groupedSkillLevels: ko.Computed<m.SkillLevelGroup[]>;

    constructor(root: root) {
        super(root);
        let self = this;

        self.id = m.FormEnum.SkillLevels;
        self.heading = "Choose Skill Level";

        self.filter(new m.Filter(root));
        
        self.filled(new m.Filled("Skill Levels"));
        self.unFilled(new m.UnFilled("Choose Skill levels"));

        self.filled().display = ko.pureComputed(() => {
            return _(root.selectedSkillLevels()).any();
        }, self);

        self.filled().summary = ko.pureComputed(() => {
            if (!self.filled().display()) { return ""; }
            return _(root.selectedSkillLevels()).pluck("name").join(", ");
        }, self);

        self.filteredSkillLevels = ko.computed(() => {
            var filter = self.filter().selected();

            return _(filter).any() ?
                _(self.skillLevels()).filter(x => x.filter(filter)) :
                self.skillLevels();
        }, self);

        self.groupedSkillLevels = ko.pureComputed(() => {
            return _.chain(self.filteredSkillLevels())
                .groupBy(x => x.program.id)
                .map((x, y) => (new m.SkillLevelGroup( { program: y, skillLevels: x }, root)))
                .value();
        }, self);

        self.next().enabled = ko.pureComputed(() => {
            return _(root.selectedSkillLevels()).any();
        }, self);

        self.next().selected = ko.pureComputed(() => {
            return _(root.selectedSkillLevels()).any() ? root.selectedSkillLevels().length : 0;
        }, self);

        self.unFilled().display = ko.pureComputed(() => {
            return !(self.active() || _(root.selectedSkillLevels()).any());
        }, self);

        self.active.subscribe(newVal => {
            if (newVal && !_(self.skillLevels()).any())
                self.getSkillLevels(root);
        });

        self.busy.subscribe(newVal => {
            App.busy(newVal);
            self.noResults(newVal ? false : !_(self.skillLevels()).any(x => x.available));
        });

        self.filteredSkillLevels.subscribe(changes => {
            self.showing().showing(changes.length);
        });

        self.skillLevels.subscribe(changes => {
            self.showing().of(changes.length);

            if (!_(changes).any())
                root.selectedSkillLevels.removeAll();
        });

        self.back = () => {
            root.chooseLocations().show();
        }

        self.filled().show = () => {
            self.show();
        }

        self.next().next = () => {
            if (!self.next().enabled()) { return false; }
            root.chooseAllocations().show();
        }

        App.onEnter("#skillLevelsSection .list-container", self.next().next);
    }

    private getSkillLevels(root: root): void {
        let self = this;

        self.busy(true);

        self.skillLevels.removeAll();

        var data = {
            locations: _(root.selectedLocations()).map(x => x.id)
        }

        Api.GetSkillLevels(data)
            .done(results => {
                //if (Api.NoResults("No Skill Level Results", results)) { return; }

                self.filter().filter(results.filter);

                var temp = self.skillLevels();

                _(results.skillLevels).each(x => temp.push(new m.SkillLevel(x, root)));

                self.skillLevels.valueHasMutated();
            })
            .always(() => self.busy(false));
    }
}